export default defineNuxtPlugin({
	name: "kredo",
	order: 1100,
	setup: () => {
		const authService = useAuth();
		const router = useRouter();

		const baseSetAuthData = authService.setAuthData.bind(authService);

		Object.assign(authService, {
			isClient() {
				return this.authData?.__isClient ?? false;
			},
			isSystemAdmin() {
				return this.isAdmin() && !this.isClient();
			},
			setAuthData(data) {
				const isSystemAdmin = this.isSystemAdmin();
				baseSetAuthData(data);
				if (!data) {
					router.push(isSystemAdmin ? "/admin/signin" : "/signin");
				}
			},
			async qesLogin(data) {
				return this.login(data, {
					link: "/api/auth/qes/signin",
					sessionData: {
						__isClient: true,
					},
				});
			},
			async diiaLogin(data) {
				return this.login(data, {
					link: "/api/auth/diia/signin",
					sessionData: {
						__isClient: true,
					},
				});
			},
			async diiaCanLogin(data) {
				return this.callAuthService("/api/auth/diia/canlogin", data, {
					showLoader: false,
					method: "GET",
				});
			},
			async diiaGetDeepLink() {
				return this.callAuthService(
					"/api/auth/diia/getdeeplink",
					null,
					{
						method: "GET",
					}
				);
			},
		});
	},
});
